export default "__VITE_ASSET__PAey$TVE__"